import React from 'react';
import Box from '@mui/material/Box';
import {SvgProps} from '../../helpers/type';

const ShieldHealth = ({className, sx}: SvgProps): JSX.Element => {
    return (
        <Box
            component="svg"
            viewBox="0 0 65 65"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            sx={sx}
        >
            <rect x="0.499634" y="0.935059" width="64" height="64" rx="32" fill="#EDFCF2" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M31.2299 19.9806C31.6527 19.8606 32.0932 19.8022 32.5332 19.8053C32.9508 19.8083 33.368 19.8667 33.7694 19.9806L43.1383 22.6401C44.7779 23.1055 45.8839 24.4121 45.8839 25.8839V33.2406C45.8839 35.9117 45.1456 38.5454 43.7289 40.9285C41.7756 44.2141 38.6237 46.8716 34.7462 48.5022L34.2216 48.7228C33.6894 48.9466 33.1119 49.0607 32.5338 49.065C31.9329 49.0695 31.3308 48.9555 30.7776 48.7228L30.2531 48.5022C26.3755 46.8716 23.2236 44.2141 21.2704 40.9285C19.8536 38.5454 19.1154 35.9117 19.1154 33.2406V25.8839C19.1154 24.4121 20.2213 23.1055 21.8609 22.6401L31.2299 19.9806ZM30.5831 29.9819C30.5831 28.9259 31.4392 28.0698 32.4952 28.0698C33.5512 28.0698 34.4072 28.9259 34.4072 29.9819V31.8856H37.4088C38.2871 31.8856 38.999 32.5976 38.999 33.4759C38.999 34.3541 38.2871 35.0661 37.4088 35.0661H34.4072V36.9713C34.4072 38.0273 33.5512 38.8833 32.4952 38.8833C31.4392 38.8833 30.5831 38.0273 30.5831 36.9713V35.0661H27.5874C26.7092 35.0661 25.9972 34.3541 25.9972 33.4759C25.9972 32.5976 26.7092 31.8856 27.5874 31.8856L30.5831 31.8856V29.9819Z"
                fill="#5D847F"
            />
            <rect x="0.999634" y="1.43506" width="63" height="63" rx="31.5" stroke="#A8EDBF" strokeOpacity="0.4" />
        </Box>
    );
};

export default ShieldHealth;
